$.fn.ExpandableRow = function(index) {
  let self = this

  self.attr('data-expandable-id', index)
  self.html('<span class="closed">' + self.html() + '</span>');
  self.append('<span class="opened">' + fondationsaintlo_l10n.COLLAPSE + '</span>')
  self.sections = self.closest('.row').nextAll('.expandable-row')

  self.sections.each(function(this_index) {
    $(this).wrap('<div class="expandable-row__wrapper" data-expandable-id="' + index + '"></div>');
    if (this_index == self.sections.length - 1) {
      $(this).append('<div class="col col-12 col-md-12 order-md-1 mt-4"><div class="text-content">' + self.closest('p').get(0).outerHTML + '</div><div>')
    }
  });

  $('.expandable-row__wrapper[data-expandable-id="' + index + '"] .toggle-expandable-row').click(function() {
    $('.expandable-row__wrapper[data-expandable-id=' + index + ']').removeClass('--opened')
    self.removeClass('--opened')
    return false;
  })

  self.click(function() {
    $('.expandable-row__wrapper[data-expandable-id=' + index + ']').toggleClass('--opened')
    $('.expandable-row__wrapper[data-expandable-id=' + index + ']').css('--max-height', $('.expandable-row__wrapper[data-expandable-id=' + index + ']').find('.row').outerHeight() + 'px')
    self.toggleClass('--opened')
  })

  return function() {
    return self
  }()
}
